module.exports = __webpack_public_path__ + "img/TailWing-Profiles.0cb45bb6.jpg";